var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78996 5.99996C7.78996 6.98996 6.98996 7.78996 5.99996 7.78996C5.00996 7.78996 4.20996 6.98996 4.20996 5.99996C4.20996 5.00996 5.00996 4.20996 5.99996 4.20996C6.98996 4.20996 7.78996 5.00996 7.78996 5.99996Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 10.1354C7.76492 10.1354 9.40992 9.09535 10.5549 7.29535C11.0049 6.59035 11.0049 5.40535 10.5549 4.70035C9.40992 2.90035 7.76492 1.86035 5.99992 1.86035C4.23492 1.86035 2.58992 2.90035 1.44492 4.70035C0.994922 5.40535 0.994922 6.59035 1.44492 7.29535C2.58992 9.09535 4.23492 10.1354 5.99992 10.1354Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.9812760f0e7094091689e9258b475341.svg";
export { ForwardRef as ReactComponent };